import * as types from '../actions/actiontypes';

const maxQueueSize = 1;
const processingTimeout = 60000;

// Documents waiting to be downloaded
const waitQueue = [];

// Documents currently being downloaded
const processingQueue = {};

function isBulkOpenAction(action) {
	return action?.meta?.docHelper?.payload && action.meta.docHelper.payload.isBulkOpen;
}

function reportDownloadStatus(style) {
	console.log('%c  Processing queue --> ', style, Object.values(processingQueue));
	console.log('%c  Waiting queue --> ', style, waitQueue);
}

function queueAction(key, value) {
	const processingCount = Object.keys(processingQueue).length;
	let isProcessingItem = false;

	const valuePayload = value.meta.docHelper.payload;

	console.log(`%cQueueing new document...`, 'color: green', valuePayload);

	if (processingCount < maxQueueSize) {
		if (!processingQueue[key]) {
			processingQueue[key] = {...value, timeStamp: Date.now()};
			isProcessingItem = true;
		}
		console.log('%cDocument added to processing queue.', 'color: green');
		reportDownloadStatus('color: green');
	} else {
		// Processing queue reached max capacity. Adding to wait queue
		waitQueue.push(value);
		console.log('%cDocument added to waiting queue.', 'color: green');
		reportDownloadStatus('color: green');
	}

	return isProcessingItem;
}

function dequeueAction(key) {
	const itemPayload = processingQueue[key]?.meta.docHelper.payload;
	console.log(`%cRemoving document from processing queue...`, 'color: #dba42c', itemPayload);
	delete processingQueue[key];

	// Queue next download:
	const nextItem = waitQueue.shift();

	reportDownloadStatus('color: #dba42c');

	return nextItem;
}

// Remove processing items from the queue if they have been there for over processingTimeout milliseconds
function cleanUpProcessingQueue() {
	const processingKeys = Object.keys(processingQueue);
	const now = Date.now;

	for (const key of processingKeys) {
		if (now - processingQueue[key].timeStamp < processingTimeout) {
			const processingItemPayload = processingQueue[key].meta.docHelper.payload;
			console.log(
				`%cProcessing download timeout. Removed from processing: ${processingItemPayload.documentName} -- ${processingItemPayload.documentId}`,
				'color: #f5f52f; background-color: #1f1f1e'
			);

			delete processingQueue[key];
		}
	}
}

/**
 * Middleware executed when a document is requested for download from bulk open feature.
 * @param {Object} config Config object.
 * @returns {Object} Next middleware execution result.
 */
export const batchDownloadMiddleware = (config) => (store) => (next) => (action) => {
	if (!isBulkOpenAction(action)) {
		return next(action);
	}

	// Download requested
	if (action.type === types.DOCHELPER_DOWNLOAD_DOCUMENT) {
		const documentId = action.meta.docHelper.payload.documentId;

		// Note: Continue running the pipeline only if the current download request can be processed.
		// Otherwise, the current request gets queued for later processing
		if (queueAction(documentId, action)) {
			return next(action);
		}
	}
};

/**
 * Middleware executed when a document finished downloading from bulk open feature.
 * @param {Object} config Config object.
 * @returns {Object} Next middleware execution result.
 */
export const batchDownloadCompleteMiddleware = (config) => (store) => (next) => (action) => {
	if (!isBulkOpenAction(action)) {
		return next(action);
	}

	// Download complete
	if (action.type === types.DOCUMENT_DOWNLOAD_COMPLETE) {
		const documentId = action.meta.docHelper.message.FileId;

		// De-queue
		const nextAction = dequeueAction(documentId);
		if (nextAction) {
			store.dispatch(nextAction);
		}
	}
	return next(action);
};
